import React from 'react'

// Constants
import { localStorageKeys } from '@sketch/constants'

// Utils
import { setStringifiedItem, getParsedItem } from '@sketch/utils'

// Icons
import { ReactComponent as Cross } from '@sketch/icons/cross-16-svg'

// Styles
import {
  Wrapper,
  Title,
  Description,
  IconContainer,
  BodyContainer,
  TextContainer,
  ActionContainer,
  Dismiss,
  Action,
} from './BannerCard.styles'

// Types
export interface BannerCardProps {
  id: string
  title: string
  description: string
  icon: React.ReactElement
  action?: React.ReactElement
  small?: boolean
  onDismiss?: (id: string) => void
  isDismissable?: boolean
}

/**
 * BannerCard renders a card like Banner
 * with some information, action and is possibly dismissable
 */
const BannerCard: React.FC<BannerCardProps> = ({
  title,
  description,
  icon,
  action,
  small,
  onDismiss,
  id,
}) => {
  const buttonSize = { size: small ? '40' : '32' }

  // For the mfa-banner,  we want to stop rendering it after a date
  // mfa-banner wont render anymore 1 day after the first render
  if (id === 'mfa-banner') {
    const stopRenderAfter = getParsedItem(localStorageKeys.mfaBanner)

    // if the date wasn't set before, set it
    if (!stopRenderAfter) {
      const oneDayFromNow = new Date(Date.now() + 3600 * 1000 * 24)

      setStringifiedItem(localStorageKeys.mfaBanner, oneDayFromNow)
    }
  }

  return (
    <Wrapper $small={small}>
      <IconContainer $small={small}>{icon}</IconContainer>
      <BodyContainer $small={small}>
        <TextContainer>
          <Title $small={small}>{title}</Title>
          <Description $small={small}>{description}</Description>
        </TextContainer>

        <ActionContainer $small={small}>
          <Action $small={small}>
            {action ? React.cloneElement(action, { ...buttonSize }) : null}
          </Action>
          {onDismiss && (
            <Dismiss
              data-testid="dismiss-button"
              onClick={() => onDismiss(id)}
              $small={small}
            >
              <Cross width="14px" height="14px" />
            </Dismiss>
          )}
        </ActionContainer>
      </BodyContainer>
    </Wrapper>
  )
}

export default BannerCard
